import {Component, inject, OnInit} from '@angular/core';
import {LicenseService} from "../../services/license.service";
import {AppLicenseViewServiceModel} from "../../services/models/app-license-view-service.model";
import {AppLicenseOverviewModel} from "../models/app-license-overview.model";
import moment from "moment";
import {LipoOverviewModel} from "../../../shared/components/models/lipo-overview.model";
import {LipoOverviewComponent} from "../../../shared/components/lipo-overview/lipo-overview.component";
import {MatDialog} from "@angular/material/dialog";
import {LicenseWizardModel} from "../models/license-wizard.model";
import {LicenseWizardDialogComponent} from "../wizard/license-wizard-dialog.component";
import {ProgressService} from "../../../shared/services/progress.service";
import {AppLicenseOverviewMapper} from "../../mappers/app-license-overview.mapper";
import {Router} from "@angular/router";
import {DatePipe} from "@angular/common";
import {LipoButton} from "../../../shared/components/models/lipo-button";

@Component({
  selector: 'du-licence-overview',
  standalone: true,
  imports: [
    LipoOverviewComponent
  ],
  templateUrl: './licence-overview.component.html',
  styleUrl: './licence-overview.component.scss'
})
export class LicenceOverviewComponent implements OnInit {
  licenseOverviewModel?: LipoOverviewModel;
  dialog = inject(MatDialog);

  constructor(
    private _licenseService: LicenseService,
    private _progressService: ProgressService,
    private readonly router: Router,
    private readonly datePipe: DatePipe,
  ) {
    _progressService.startLoading()
  }

  ngOnInit(): void {
    this.initData()
  }

  initData(): void {
    this._licenseService.getAppLicenses().subscribe({
      next: (licenses: AppLicenseViewServiceModel[]) => {
        this.processLicenses(licenses);
      },
      complete: () => this._progressService.stopLoading()
    });
  }

  private processLicenses(licenses: AppLicenseViewServiceModel[]): void {
    const licenseOverviews = licenses.map(license => new AppLicenseOverviewModel(
      license.id,
      moment(license.purchaseDate),
      moment(license.expiryDate),
      license.logo,
      license.tenant,
      license.system,
      license.customer,
      license.product,
      license.isActive,
      license.isActive ? "active" : "idle"
    ));

    const licenseCards = licenseOverviews.map(AppLicenseOverviewMapper.toLipoCard);
    const licenseTable = AppLicenseOverviewMapper.toLipoTable(licenseOverviews, this.router, this.datePipe)

    this.licenseOverviewModel = {
      title: 'license',
      buttons: LipoButton.build({
        text: "button.license.activate",
        icon: "license",
        onClick: async () => this.onLicenseWizardClicked()
      }),
      cards: licenseCards,
      table: licenseTable,
    };
  }

  onLicenseWizardClicked(): void {
    this.dialog.open(LicenseWizardDialogComponent, {
      data: new LicenseWizardModel({}),
    }).afterClosed().subscribe({
      next: result => {
        if(result) {
          this.initData();
        }
      }
    })
  }

}
